var _defs, _g, _path, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    "data-name": "Livello 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 681.9 162.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #003087;\r\n        stroke-width: 0px;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.6,21.6c-9.1,0-16.9,4.4-19.1,12.6l10,1.4c1-3,3.7-5.8,9.1-5.8s7.6,3.3,7.6,6.3-1,3.9-9.4,4.7C10.1,41.8,0,43.4,0,54.9h0c0,8.5,6.4,13.4,15.2,13.4s10.1-1.6,13.2-7h.3v6.1h10.1v-30.1c0-10.1-6.8-15.7-18.3-15.7h0ZM28.4,50.5c0,6.4-4.4,10.1-10.5,10.1s-7.8-1.3-7.8-6.1,5.8-6.1,11.2-6.8c2.7-.3,5.4-.7,7.1-1.7v4.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M48.2,51.2v-28.7h10.8v26.4c0,7.1,4.1,10.1,8.5,10.1s9.5-3.7,9.5-10.1v-26.4h10.8v45h-10.5v-7.8h-.3c-2.4,5.4-7.1,8.8-13.5,8.8-9.5,0-15.2-5.8-15.2-17.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M102.3,30.5h-6.4v-8.1h6.4v-11.3h10.8v11.3h8.8v8.1h-8.8v23.2c0,4.1,2,5.4,4.4,5.4s2.5-.3,3.4-.5l1.7,8.7c-2,.7-4.4,1-6.4,1-7.8,0-13.9-4.7-13.9-12.8v-24.9h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M148.6,21.6c-13.5,0-21.6,9.8-21.6,23.3s8.4,23.3,21.6,23.3,21.6-9.8,21.6-23.3-8.4-23.3-21.6-23.3ZM148.6,59.8c-7.4,0-10.8-7.1-10.8-14.9s2.7-14.9,10.8-14.9,10.8,6.8,10.8,14.9-3.4,14.9-10.8,14.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M201.2,41.7c8.1,1.8,12.6,5.3,12.6,12.8s-9.1,13.8-19.3,13.8-17.9-4.4-19.3-13.2l10.5-1c1,4.7,4.1,6.1,8.8,6.1s8.4-2.4,8.4-5.4-2.7-4.3-6.1-5.1l-7.8-1.7c-7.5-1.6-12.5-5.1-12.5-12.5s8.6-13.9,18.3-13.9,16.6,4.7,17.9,12.5l-9.5,1c-1-3.4-4.2-5.5-8.4-5.5s-7.8,1.8-7.8,5.2,2.6,4.3,6.3,5.1l7.8,1.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M275.1,31.2c-5.8,0-10.1,4.1-10.1,10.1v26h-10.8V22.4h10.5v7.4h.3c2-5.8,6.8-8.1,11.5-8.1s2.2,0,3.4.3v9.7c-1.2-.3-2.9-.5-4.7-.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M303.4,21.6c-9.1,0-16.9,4.4-19.1,12.6l10,1.4c1-3,3.7-5.8,9.1-5.8s7.6,3.3,7.6,6.3-1,3.9-9.4,4.7c-8.7.9-18.8,2.5-18.8,14h0c0,8.5,6.4,13.4,15.2,13.4s10.1-1.6,13.2-7h.3v6.1h10.1v-30.1c0-10.1-7.4-15.7-18.3-15.7h0ZM311.2,50.5c0,6.4-4.4,10.1-10.5,10.1s-7.8-1.3-7.8-6.1,5.8-6.1,11.2-6.8c2.7-.3,5.4-.7,7.1-1.7v4.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M361.3,11.2v18.6h-.7c-2.5-5.3-6.9-8-12.8-8.1-11,0-18.5,9.4-18.6,23.3.1,12.6,6.8,23.2,18.6,23.3,6.1-.2,10.8-3.6,12.8-8.1h.7v7.2h10.5V11.2h-10.5ZM350.8,59.5c-7.1,0-10.7-6.6-10.8-14.5.1-8.7,3.7-14.5,10.8-14.5s10.6,6.4,10.5,14.5c.1,7.6-3.1,14.5-10.5,14.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M401.5,59.8c-7.2.1-11.5-5-11.5-12.2h31.1v-3c0-14.2-7.4-22.9-20.3-23-13.5,0-21.5,9.6-21.3,23.3-.1,14.3,8.2,23.3,21.6,23.3,7.5,0,17.4-3.4,19.6-13.2l-9.8-1c-1.6,4.4-5.7,5.9-9.5,5.8h0ZM401.1,30.1c6-.1,10.2,4.8,10.1,10.5h-21c.2-4.8,3.8-10.6,10.8-10.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M224.6,30.5h-6.4v-8.1h6.4v-11.3h10.8v11.3h8.8v8.1h-8.8v23.2c0,4.1,2,5.4,4.4,5.4s2.5-.3,3.4-.5l1.7,8.7c-2,.7-4.4,1-6.4,1-7.8,0-13.9-4.7-13.9-12.8v-24.9h0Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M642.8,78.1h-16.7v-27.9C626.1,22.5,603.6,0,575.9,0s-50.2,22.5-50.2,50.2v27.9h-44.6v22.3h44.6v44.6h22.3v-44.6h55.8v16.7c0,21.6,17.5,39.1,39,39.1s39-17.5,39-39.1-17.5-39.1-39-39.1h0ZM548,78.1v-28.5c0-15.4,12.5-27.9,27.9-27.9s27.9,12.5,27.9,27.9v28.5h-55.8ZM642.8,133.9c-9.2,0-16.7-7.5-16.7-16.7v-16.7h16.7c9.2,0,16.7,7.5,16.7,16.7s-7.5,16.7-16.7,16.7Z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 352,
    y: 86.9,
    width: 16.6,
    height: 13.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M31.3,98.1c-5.9,0-10.9,3.3-13,8.7h-.4v-8.1H1.4v63.7h16.6v-25h.2c2.1,5.1,7.2,8.3,12.9,8.3,11.3,0,18.2-9.7,18.2-23.8s-6.4-23.8-18.1-23.8h0ZM32.1,122c0,6.1-2.2,11-7.2,11s-7.4-5.2-7.4-11,2.3-11,7.4-11,7.2,5,7.2,11h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M100.8,125.8v-3.9c0-14.3-8.8-23.8-23-23.8s-23.5,8.6-23.5,23.9,8.1,23.7,23.9,23.7,20.8-4.1,22.7-15.6h-15.2c-1,2.6-4,4.1-7.1,4.1-4.8,0-7.8-3.1-7.8-7.7v-.7h30.2,0ZM70.6,116.6c.1-4.1,3.7-6.8,7.5-6.8s7.3,2.8,7.3,6.8h-14.8,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M139.1,112.7c-2-.4-3.7-.6-5.5-.6-4.7,0-9.2,2.2-9.2,9.3v23.6h-16.7v-46.3h16.2v8.8h.5c1.3-5.9,5.2-9.4,10.6-9.4s2.7.2,4.1.6v13.9h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M267.5,144.3c-3.7.9-7.3,1.4-10.5,1.4-8.9,0-15-4-15-14v-19.3h-5.9v-12.1h5.9v-13.5h16.7v13.5h8v12.1h-8v17.7c0,2.2,1.4,2.9,3.2,2.9s2-.1,3.2-.4l2.4,11.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M398.4,98.1c-11.5,0-20.5,5.4-21.2,15.7h15.3c.4-3.1,2.8-4.2,5.7-4.2s5,1.2,5,3.7-1.7,3.3-7.2,3.9c-13.3,1.3-20.5,4.5-20.5,15.1s6.1,13.5,15.1,13.5,10.6-2,13.4-7.2h.4v6.5h15.6v-29.8c0-10.7-6.5-17.1-21.4-17.1h0ZM403.2,128.8c0,4.1-3.4,6.6-7.4,6.6s-4.8-1.2-4.8-4,3.6-4.5,7.2-5.1c1.8-.3,3.7-.6,5-1.4v3.9h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M295.9,98.1c-11.5,0-20.5,5.4-21.2,15.7h15.3c.4-3.1,2.8-4.2,5.7-4.2s5,1.2,5,3.7-1.7,3.3-7.2,3.9c-13.3,1.3-20.5,4.5-20.5,15.1s6.1,13.5,15.1,13.5,10.6-2,13.4-7.2h.4v6.5h15.6v-29.8c0-10.7-6.5-17.1-21.4-17.1h0ZM300.7,128.8c0,4.1-3.4,6.6-7.4,6.6s-4.8-1.2-4.8-4,3.6-4.5,7.2-5.1c1.8-.3,3.7-.6,5-1.4v3.9h0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 162.2,
    y: 86.9,
    width: 16.6,
    height: 58.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 212.2,
    y: 86.9,
    width: 16.6,
    height: 58.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 326.3,
    y: 86.9,
    width: 16.6,
    height: 58.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 352,
    y: 105.5,
    width: 16.6,
    height: 39.6
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "184.7 105.5 196.8 105.5 204.4 86.9 188.2 86.9 184.7 105.5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.7b94d2b39624a6da7d75245e83107da4.svg";
export { ForwardRef as ReactComponent };